import { render, staticRenderFns } from "./OnboardingWelcome.vue?vue&type=template&id=47bb60b8&scoped=true"
import script from "./OnboardingWelcome.vue?vue&type=script&lang=js"
export * from "./OnboardingWelcome.vue?vue&type=script&lang=js"
import style0 from "./OnboardingPage.scss?vue&type=style&index=0&id=47bb60b8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb60b8",
  null
  
)

export default component.exports